import React from 'react';

function HUD({ mission, round, trust, xp, geniusFlags }) {
  const maxTrust = 6;
  const minTrust = -3;
  const trustRange = maxTrust - minTrust;
  const trustPercent = ((trust - minTrust) / trustRange) * 100;
  const clampedPercent = Math.max(2, Math.min(98, trustPercent));

  const trustColor = trust > 2 ? '#00ff41' : trust > 0 ? '#00d4ff' : trust === 0 ? '#555568' : '#ff0040';

  return (
    <div className="hud">
      <div className="hud-section hud-left">
        <span className="hud-module">{mission.moduleId}</span>
        <span className="hud-divider">/</span>
        <span className="hud-title">{mission.title}</span>
      </div>

      <div className="hud-section hud-center">
        <div className="hud-trust-container">
          <span className="hud-label">TRUST</span>
          <div className="trust-bar-track">
            <div
              className="trust-bar-fill"
              style={{ width: `${clampedPercent}%`, backgroundColor: trustColor }}
            />
            <div className="trust-bar-midline" />
          </div>
          <span className="hud-trust-value" style={{ color: trustColor }}>
            {trust > 0 ? '+' : ''}{trust}
          </span>
        </div>
      </div>

      <div className="hud-section hud-right">
        <span className="hud-round">R{round + 1}/3</span>
        <span className="hud-xp">{xp} XP</span>
        {geniusFlags.length > 0 && (
          <span className="hud-genius" title="Genius flag detected">&#x1F9E0;</span>
        )}
      </div>
    </div>
  );
}

export default HUD;
